import { Api } from "@/api";
import { UserType, PaginationType, UserLoginType } from "@/DTO";
import { ConvertToPaginationType } from "@/api/help";
import { ConvertToUserType } from "@/api/user/get";

export const GetUserList = (user: UserLoginType, pagination: PaginationType, phone?: string) => {
  return new Promise<{
    data: UserType[]
    pagination: PaginationType
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `user`,
      params: {
        page: pagination.currentPage,
        per_page: pagination.perPage,
        phone: phone
      },
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToUserListType(data.data),
          pagination: ConvertToPaginationType(data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToUserListType = (data: any[]): UserType[] => {
  const returnData = data.map((item) => {
    return ConvertToUserType(item);
  });
  return returnData;
};

